<template>
  <chart-layout :title="title" :yAxis="yAxis" :xAxis="xAxis">
    <bar-graph
      :chart-data="data"
      :chart-id="chartIdOverride"
      :type="type">
    </bar-graph>
  </chart-layout>
</template>

<script>
import BarGraph, {types} from '@/components/graphs/BarGraph'
import ChartLayout from '@/components/layouts/ChartLayout'

export default {
  components: {
    BarGraph,
    ChartLayout
  },
  props: {
    chartIdOverride: {
      type: String,
      default: 'age-market-breaker-graph'
    },
    data: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  data () {
    return {
      yAxis: 'Viewship %',
      xAxis: 'Age Market Breakers',
      type: types.PERCENTAGE
    }
  },
  computed: {
    title () {
      return `Market Age Breakers Distribution (Mean Age ${this.meanAge})`
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AgeMarketBreakerGraph.vue?14b4ba32